module.exports = __webpack_public_path__ + "img/ic_in.30dfffac.svg";